var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "page-card page-card--green" },
    [
      _c(
        "v-content-section",
        {
          ref: "visual",
          staticClass: "page-card__visual",
          attrs: { content: _vm.content, variant: "white" }
        },
        [
          _c("v-icon", {
            ref: "visualCard",
            staticClass: "content-section__card",
            attrs: { name: "symbols/cards/green" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "carousel", staticClass: "carousel carousel--green" },
        [
          _c("div", { staticClass: "carousel__absolute" }, [
            _c(
              "div",
              {
                ref: "background",
                class: [
                  "carousel__background",
                  { "carousel__background--sticky": !_vm.isIE }
                ]
              },
              [
                _vm._l(_vm.backgrounds, function(key, keyIndex) {
                  var _obj
                  return [
                    _c("div", {
                      class:
                        ((_obj = {}),
                        (_obj[
                          "carousel__background-item carousel__background--" +
                            key.bg
                        ] = true),
                        (_obj["carousel__background--" + key.bg + "-active"] =
                          _vm.currentSlide === keyIndex),
                        _obj)
                    })
                  ]
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "carousel__row", attrs: { variant: "flex" } },
            [
              _c("v-column", { attrs: { large: 12 } }, [
                _c("div", { staticClass: "carousel__wrapper" }, [
                  _c("div", { ref: "sticky", staticClass: "carousel__left" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "carousel__sticky",
                          { "carousel__sticky--active": !_vm.isIE }
                        ]
                      },
                      [
                        _c("div", { staticClass: "carousel__sticky-wrapper" }, [
                          _c(
                            "div",
                            {
                              ref: "animationWrapper",
                              staticClass: "carousel__image-wrapper"
                            },
                            [
                              _c(
                                "div",
                                {
                                  ref: "orkaCardGreen",
                                  staticClass:
                                    "carousel__visual carousel__visual--svg"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "carousel__visual-icons" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: "carouselSlide1",
                                          staticClass:
                                            "carousel__slide carousel__slide--0"
                                        },
                                        [
                                          _c("v-icon", {
                                            attrs: {
                                              name: "benefits/green/download"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-icon", {
                                            attrs: {
                                              name: "benefits/green/message"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-icon", {
                                            attrs: {
                                              name: "benefits/green/user-valid"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "carouselSlide2",
                                          staticClass:
                                            "carousel__slide carousel__slide--1"
                                        },
                                        [
                                          _c("v-icon", {
                                            attrs: {
                                              name:
                                                "benefits/green/notification"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-icon", {
                                            attrs: {
                                              name: "benefits/green/card-valid"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-icon", {
                                            attrs: {
                                              name: "benefits/green/finger"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "carouselSlide3",
                                          staticClass:
                                            "carousel__slide carousel__slide--2"
                                        },
                                        [
                                          _c("v-icon", {
                                            attrs: {
                                              name: "benefits/green/face-id"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-icon", {
                                            attrs: {
                                              name: "benefits/green/savings"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "carousel__visual-svg" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: "carouselVisualCard",
                                          staticClass: "carousel__visual-card"
                                        },
                                        [
                                          _c("v-icon", {
                                            attrs: {
                                              name: "symbols/cards/green"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-icon", {
                                        staticClass:
                                          "carousel__visual-svg--card",
                                        attrs: {
                                          name: "symbols/letters/a-green"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "svg icon" }, [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              viewBox: "0 0 251 500",
                                              width: "251px",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href": "#ui/mock"
                                              }
                                            })
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "carousel__visual-image-wrapper"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              ref: "carouselSlideImage1",
                                              staticClass:
                                                "carousel__visual-image"
                                            },
                                            [
                                              _c("v-image", {
                                                attrs: {
                                                  alt: _vm.$t(
                                                    "cards.white.carousel.account.alt"
                                                  ),
                                                  "aspect-ratio": 219 / 472,
                                                  tiny: {
                                                    default: require("@/images/green/carousel/static/0.png"),
                                                    retina: require("@/images/green/carousel/static/0@2.png")
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              ref: "carouselSlideImage2",
                                              staticClass:
                                                "carousel__visual-image"
                                            },
                                            [
                                              _c("v-image", {
                                                attrs: {
                                                  alt: _vm.$t(
                                                    "cards.white.carousel.account.alt"
                                                  ),
                                                  "aspect-ratio": 219 / 472,
                                                  tiny: {
                                                    default: require("@/images/green/carousel/static/2.png"),
                                                    retina: require("@/images/green/carousel/static/2@2.png")
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              ref: "carouselSlideImage3",
                                              staticClass:
                                                "carousel__visual-image"
                                            },
                                            [
                                              _c("v-image", {
                                                attrs: {
                                                  alt: _vm.$t(
                                                    "cards.white.carousel.account.alt"
                                                  ),
                                                  "aspect-ratio": 219 / 472,
                                                  tiny: {
                                                    default: require("@/images/green/carousel/static/1.png"),
                                                    retina: require("@/images/green/carousel/static/1@2.png")
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "carousel__right" }, [
                    _c(
                      "div",
                      { staticClass: "carousel__item" },
                      [
                        _vm._l(1, function(i) {
                          return [
                            _c(
                              "div",
                              {
                                ref: "content",
                                refInFor: true,
                                staticClass: "carousel__content"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "carousel__content-inner" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        ref: "contentTrigger",
                                        refInFor: true,
                                        staticClass:
                                          "carousel__headline-wrapper"
                                      },
                                      [
                                        _c("v-typo", {
                                          staticClass: "carousel__headline",
                                          attrs: { variant: "h2" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "cards.green.slider.sections.0.content.headline"
                                              )
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-typo", {
                                      staticClass: "carousel__paragraph",
                                      attrs: { variant: "body-paragraph" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "cards.green.slider.sections.0.content.perex"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "carousel__content-image"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            "aspect-ratio": 234 / 420,
                                            tiny: {
                                              default: require("@/images/green/carousel/static/mobile/0.png"),
                                              retina: require("@/images/green/carousel/static/mobile/0@2.png")
                                            },
                                            alt: "todo fill alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                ref: "content",
                                refInFor: true,
                                staticClass: "carousel__content"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "carousel__content-inner" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        ref: "contentTrigger",
                                        refInFor: true,
                                        staticClass:
                                          "carousel__headline-wrapper"
                                      },
                                      [
                                        _c("v-typo", {
                                          staticClass: "carousel__headline",
                                          attrs: { variant: "h2" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "cards.green.slider.sections.1.content.headline"
                                              )
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-typo", {
                                      staticClass: "carousel__paragraph",
                                      attrs: { variant: "body-paragraph" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "cards.green.slider.sections.1.content.perex"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "carousel__content-image"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            "aspect-ratio": 266 / 378,
                                            tiny: {
                                              default: require("@/images/green/carousel/static/mobile/1.png"),
                                              retina: require("@/images/green/carousel/static/mobile/1@2.png")
                                            },
                                            alt: "todo fill alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                ref: "content",
                                refInFor: true,
                                staticClass: "carousel__content"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "carousel__content-inner" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        ref: "contentTrigger",
                                        refInFor: true,
                                        staticClass:
                                          "carousel__headline-wrapper"
                                      },
                                      [
                                        _c("v-typo", {
                                          staticClass: "carousel__headline",
                                          attrs: { variant: "h2" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "cards.green.slider.sections.2.content.headline"
                                              )
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-typo", {
                                      staticClass: "carousel__paragraph",
                                      attrs: { variant: "body-paragraph" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "cards.green.slider.sections.2.content.perex"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "carousel__content-image"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            "aspect-ratio": 234 / 420,
                                            tiny: {
                                              default: require("@/images/green/carousel/static/mobile/2.png"),
                                              retina: require("@/images/green/carousel/static/mobile/2@2.png")
                                            },
                                            alt: "todo fill alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }